export class AutoLockRulesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAutoLockRules() {
    return this.#http.get('/api/auto-lock-fields-rules');
  }

  async createAutoLockRule(body) {
    return this.#http.post('/api/auto-lock-fields-rules', body);
  }

  async editAutoLockRule({ id, ...body }) {
    return this.#http.put(`/api/auto-lock-fields-rules/${id}`, body);
  }

  async deleteAutoLockRule({ id }) {
    return this.#http.delete(`/api/auto-lock-fields-rules/${id}`);
  }

  async getApplicationLockedFields({ applicationId }) {
    // Loan-editor secondary read: degrade (not global reload loop) on a subtree-scoped TPO
    // broker 403 (DEV-4226).
    return this.#http.get(`/api/applications/${applicationId}/locked-fields`, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async getAutoLockFieldRulesExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/auto-lock-field-rules');
  }

  async recalculateAutoLockRules() {
    return this.#http.post('/api/auto-lock-fields-rules/recalculate');
  }

  async reorderAutoLockRule(body) {
    return this.#http.post(`/api/auto-lock-fields-rules/reorder`, body);
  }
}
